import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import DiscoveryPanel from '../components/DiscoveryPanel';
import Header from '../components/Header';
import SidePanel from '../components/SidePanel';
import SynthesisManager from '../components/SynthesisManager';
import TriggersManager from '../components/TriggersManager';
import { useNavigate } from 'react-router-dom';
import { useUserQuery } from '../endpoints/user';
import OperationsManager from '../components/OperationsManager';

const headerStyles = (opened) => ({
  width: opened ? 'calc(100% - 620px)' : '100%',
  transition: 'width 0.1s ease-in-out',
});

const mainStyles = (opened) => ({
  width: opened ? 'calc(100% - 620px)' : '100%',
  transition: 'width 0.1s ease-in-out',
});

const Home = () => {
  const user = useUserQuery();
  const navigate = useNavigate();
  const [panelNumber, setPanelNumber] = useState(0);
  const [isEditing, setisEditing] = useState(false);
  const [firstOpen, setFirstOpen] = useState(true);
  const [isStaffUser, setIsStaffUser] = useState(false);
  const updateIsEditing = () => {
    setisEditing(!isEditing);
  };

  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();

  useEffect(() => {
    if (panelNumber !== 0) {
      setFirstOpen(false);
    }
  }, [panelNumber]);

  useEffect(() => {
    if (!user.isLoading && !user.isSuccess) {
      navigate('/login');
    }
    if (!user.isLoading && user.isSuccess && user?.data[0]?.is_staff) {
      setIsStaffUser(true);
    }
  }, [user]);

  const handlePanelChange = (newPanelNumber) => {
    if (newPanelNumber === 0 && panelNumber !== 0) {
      setisEditing(false);
    }
    setPanelNumber(newPanelNumber);
  };

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened },
      }}
      padding="md"
    >
      <AppShell.Header style={headerStyles()}>
        <Header
          user={user}
          mobileOpened={mobileOpened}
          toggleMobile={toggleMobile}
        />
      </AppShell.Header>
      <AppShell.Navbar>
        <SidePanel
          handlePanelChange={handlePanelChange}
          panelNumber={panelNumber}
          isStaffUser={isStaffUser}
        />
      </AppShell.Navbar>
      <AppShell.Main style={mainStyles()}>
        {panelNumber === 0 && (
          <DiscoveryPanel
            setShowChatLogo={updateIsEditing}
            firstOpen={firstOpen}
            setFirstOpen={(value) => setFirstOpen(value)}
          />
        )}
        {panelNumber === 1 && <SynthesisManager />}
        {panelNumber === 2 && <TriggersManager />}
        {panelNumber === 3 && <></>}
        {panelNumber === 4 && isStaffUser && <OperationsManager />}
      </AppShell.Main>
    </AppShell>
  );
};

export default Home;
